import { FC } from 'react';
import styled from 'styled-components';
import { useState } from '@hookstate/core';
import { SideGamesList } from '../SideGamesList';
import { Footer } from '../Footer';
import { Loading } from '../../components/Loading';
import { useBoughtTickets } from '../../hooks/use-bought-tickets';
import {
    FOOTER_HEIGHT_REM,
    PADDING_VERTICAL_REM,
} from '../../components/FooterSG';
import {
    current as currentState,
    meta as metaState,
    next as nextState,
} from '../../stores/backend';

const PADDING_HORIZONTAL = FOOTER_HEIGHT_REM + PADDING_VERTICAL_REM;

export const SideGamesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4rem 1.5rem ${PADDING_HORIZONTAL}rem;
    flex: 1 1 auto;
    overflow: auto;
`;

export const SideGames: FC = () => {
    const current = useState(currentState);
    const next = useState(nextState);
    const meta = useState(metaState);
    const bought = useBoughtTickets(current);

    const gameMode = current.game_mode.value;

    if (
        !current.game_sid.value ||
        !meta.loaded.screenConfig.value ||
        (gameMode === 'GAME_MODE' && bought === 0 && !next.game_sid.value)
    ) {
        return <Loading />;
    }

    return (
        <SideGamesContainer>
            <SideGamesList />
            <Footer />
        </SideGamesContainer>
    );
};
